import { render, staticRenderFns } from "./iconNational.vue?vue&type=template&id=a4c06364&scoped=true"
import script from "./iconNational.vue?vue&type=script&lang=js"
export * from "./iconNational.vue?vue&type=script&lang=js"
import style0 from "./iconNational.vue?vue&type=style&index=0&id=a4c06364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c06364",
  null
  
)

export default component.exports